import React from 'react';
import accounting from 'accounting'

import {
    Table,
    Card,
    Row,
} from 'antd'

import {
    _getAllCreditBalances,
    _postWithdrawCredit
} from '../../services';

import EntitySearch from './entity-search';
class CreditOverview extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            creditBalances: [],
            loading: true,

            entityType: '',
            entityId: '',
        }
    }

    render(){
        return(
            <Card
                title={
                    <Row type="flex" justify="start">
                        Credit Overview
                    </Row>
                }
            >
                <EntitySearch 
                    onEntityNameSelected={this.onEntityNameSelected}
                    />
                {this.renderTable()}
            </Card>
        )
    }

    componentDidMount() {
        this.getAllCreditBalances()
    }

    getAllCreditBalances = () => {

        const { entityType, entityId } = this.state;

        this.setState({
            loading: true
        })

        _getAllCreditBalances({currency: 'SGD', entityType, entityId })
        .then(_creditBalances => {
            this.setState({
                loading: false,
                creditBalances: _creditBalances.data
            })
        })
    }

    renderTable = () => {

        const {loading, creditBalances} = this.state;

        const columns = [{
            title: 'Entity Type',
            dataIndex: 'entityType',
        },{
            title: "Entity Id",
            dataIndex: 'entityId'
        },{
            title: "Entity Name",
            dataIndex: 'entityName'
        },{
            title: "Credit Balance",
            dataIndex: 'creditBalance',
            render: (creditBalance) => accounting.formatMoney( creditBalance, '$', 2)
        },{
            title: "Debit Balance",
            dataIndex: 'debitBalance',
            render: (debitBalance) => accounting.formatMoney( debitBalance, '$', 2)
        },{
            title: "Actions",
            dataIndex: '_id',
            render: (_id, record) => this.renderActions(_id, record)
        }]

        return (
            <Table
                loading={loading}
                dataSource={creditBalances}
                columns={columns}
            />
        )
    }

    renderActions = (_id, record) => {

        return (
            <Row>
                <a
                    href={`/credit-overview/${record.entityType}/${record.entityId}`}
                    target={`_blank`}
                >
                    View
                </a>
            </Row>
        )
    }

    onEntityNameSelected = ({ entityType, entityId }) => {
        this.setState({
            entityType,
            entityId
        },this.getAllCreditBalances)
    }

}

export default CreditOverview


// WEBPACK FOOTER //
// ./src/components/credit-overview/index.js